// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hf","advertCardFooter__row":"c-a_hg","advertCardFooter__name":"c-a_hh","advertCardFooter__price":"c-a_hi","advertCardFooter__age":"c-a_hj"};